<template>
  <div>
    <carousel
      ref="carousel"
      class="carousel"
      :paginationEnabled="false"
      :perPageCustom="[[0, 1], [760, 2]]"
    >
      <slide>
        <header>
          <h1 class="text-primary survey__begin__title">
            {{ labels.greeting }},
          </h1>
          <h4 class="text-gray02 mb-4 survey__begin__description">
            {{ labels.headerTextOne }}
          </h4>
          <h4 class="text-gray03 mt-4 survey__begin__description">
            {{ labels.headerTextTwo }}
            {{ nextSurveyDate | moment('DD/MM/YY') }}
          </h4>
          <b-button
            variant="blue"
            class="next-button mt-4"
            @click="$refs.carousel.handleNavigation('foward')"
          >
            {{ labels.understoodButton }}
          </b-button>
        </header>
      </slide>
      <slide>
        <div class="custom-divider mt-4 mb-4"></div>
        <main key="main">
          <transition appear name="suggestion-fade" mode="out-in">
            <survey-suggestion :showBackToHome="true" />
          </transition>
        </main>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { path } from 'ramda'
import SurveySuggestion from '@/components/Survey/SurveySuggestion.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
  components: {
    SurveySuggestion,
    Carousel,
    Slide,
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      surveyError: 'survey/surveyError',
    }),
    labels() {
      return path(
        ['component', 'survey', 'begin', 'surveyBeginUnauthorized'],
        this.resources
      )
    },
    nextSurveyDate() {
      return path(['data', 'nextDeliverySurveyDate'], this.surveyError)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.custom-divider {
  border-top: 1px solid map-get($theme-colors, 'gray00');
  display: none;
  margin: 1em 1.5em 0;

  @include media-breakpoint-up(sm) {
    display: block;
  }
}

.btn,
::v-deep .btn {
  display: block;
  width: 100%;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    width: 200px;
  }
}

::v-deep .suggestion__description {
  font-size: 0.9em;

  @include media-breakpoint-up(lg) {
    font-size: 1.5em;
  }
}

::v-deep .suggestion__button,
.next-button {
  font-size: 0.7em;

  &:focus {
    box-shadow: none;
  }

  @include media-breakpoint-up(lg) {
    font-size: 1em;
  }
}

.next-button {
  @include media-breakpoint-up(sm) {
    display: none;
  }
}

::v-deep .carousel .VueCarousel-inner {
  @include media-breakpoint-up(sm) {
    flex-direction: column;
  }
}

::v-deep .carousel .VueCarousel-slide {
  @include media-breakpoint-up(sm) {
    flex-basis: auto;
  }
}

@include media-breakpoint-up(lg) {
  .suggestion-fade-enter-active {
    opacity: 0;
    animation: changeOpacity 1.5s 1s;
  }

  @keyframes changeOpacity {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .suggestion-fade-enter {
    opacity: 0;
  }
}
</style>
